import React, { useState, useEffect } from "react";
import { Row, Col, Button, Card } from "react-bootstrap";
import Axios from "axios";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as ControllerStyles from "../styles/controller";

//COMPONENTS
import AddBlog from "./addBlog";

function Controller() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [addBlogModal, setAddBlogModal] = useState({
    open: false,
  });
  const [blogs, setBlogs] = useState([]);

  function handleCloseAddBlogModal() {
    setAddBlogModal((prevState) => {
      return { ...prevState, open: false };
    });
  }

  function handleOpenAddBlogModal() {
    setAddBlogModal((prevState) => {
      return { ...prevState, open: true };
    });
  }

  useEffect(() => {
    dispatch(GS_navSettingsActions.UpdateTitle("Blogs"));
    dispatch(GS_navSettingsActions.UpdateSelected("Features"));
    dispatch(GS_navSettingsActions.UpdateSubSelected("Blogs"));
    loadBlogs();
  }, []);

  function loadBlogs() {
    Axios.post("/pods/CPOD_BLOGS_ADMIN/loadBlogs")
      .then((res) => {
        const data = res.data;
        if (data.error == "null") {
          setBlogs(data.blogs);
        }
      })
      .catch((err) => console.log(err));
  }

  function handleBlogClick(id) {
    navigate(`./${id}`);
  }

  return (
    <div style={ControllerStyles.body}>
      <Row>
        <Col style={ControllerStyles.addButton}>
          <Button onClick={handleOpenAddBlogModal}>Add Blog</Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card style={ControllerStyles.titlesCardStyle}>
            <Card.Body>
              <Row>
                <Col>Title</Col>
                <Col>Posts</Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <br />
      <Row>
        <div style={ControllerStyles.blogsContainer}>
          {blogs.map((blog, index) => {
            return (
              <div key={index}>
                <Card
                  style={ControllerStyles.cardStyle}
                  onClick={handleBlogClick.bind(this, blog.uuid)}
                >
                  <Card.Body>
                    <Row>
                      <Col>{blog.title}</Col>
                      <Col>{blog.noOfPosts}</Col>
                    </Row>
                  </Card.Body>
                </Card>
                <br />
              </div>
            );
          })}
        </div>
      </Row>

      <AddBlog open={addBlogModal.open} close={handleCloseAddBlogModal} />
    </div>
  );
}

export default Controller;
